import { createTextVNode as _createTextVNode, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6388ca43")

_pushScopeId("data-v-6388ca43")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("AI自動返信設定")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "AI自動返信を有効にする", -1)
const _hoisted_4 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_5 = {
  for: "useAiReply",
  class: "flex flex-row items-center gap-2 cursor-pointer"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" AI自動返信を有効にする ")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_9 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_10 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "返信に間隔をあける", -1)
const _hoisted_12 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_13 = {
  for: "setIntervalForReply",
  class: "flex flex-row items-center gap-2 cursor-pointer"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 返信に間隔をあける ")
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_17 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_18 = { class: "flex flex-row" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 設定を更新 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MTextArea = _resolveComponent("MTextArea")
  const _component_MTextField = _resolveComponent("MTextField")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { onClose: _ctx.close }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode("label", _hoisted_5, [
            _withDirectives(_createVNode("input", {
              id: "useAiReply",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.useAiReply = $event)),
              type: "checkbox",
              name: "add-role",
              class: "h-4 w-4 border-gray-300 rounded"
            }, null, 512), [
              [_vModelCheckbox, _ctx.useAiReply]
            ]),
            _hoisted_6
          ])
        ])
      ]),
      (_ctx.useAiReply)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_MTextArea, {
                label: "入室フォームへの返信用プロンプト ※末尾にフォームの内容が自動で挿入されます。",
                name: "enterPrompt",
                placeholder: "入室フォームへの返信用プロンプトを入力してください",
                value: _ctx.enterPrompt,
                onInput: _cache[2] || (_cache[2] = 
              e => {
                _ctx.onInputPrompt(e, 'enter');
              }
            ),
                onEnter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onPromptBlur('enter')))
              }, null, 8, ["value"])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_MTextArea, {
                label: "退室フォームへの返信用プロンプト ※末尾にフォームの内容が自動で挿入されます。",
                name: "leavePrompt",
                placeholder: "退室フォームへの返信用プロンプトを入力してください",
                value: _ctx.leavePrompt,
                onInput: _cache[4] || (_cache[4] = 
              e => {
                _ctx.onInputPrompt(e, 'leave');
              }
            ),
                onEnter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onPromptBlur('leave')))
              }, null, 8, ["value"])
            ]),
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode("div", _hoisted_12, [
                _createVNode("label", _hoisted_13, [
                  _withDirectives(_createVNode("input", {
                    id: "setIntervalForReply",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.setIntervalForReply = $event)),
                    type: "checkbox",
                    name: "add-role",
                    class: "h-4 w-4 border-gray-300 rounded"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.setIntervalForReply]
                  ]),
                  _hoisted_14
                ])
              ])
            ]),
            (_ctx.setIntervalForReply)
              ? (_openBlock(), _createBlock("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode(_component_MTextField, {
                      label: "間隔の下限(分)",
                      name: "min",
                      type: "number",
                      placeholder: "間隔の下限を入力してください",
                      value: String(_ctx.min),
                      invalid: !_ctx.isMinValid,
                      "invalid-message": _ctx.minInvalidMessage,
                      entered: "",
                      onInput: _ctx.onMinInput,
                      onEnter: _ctx.onMinBlur
                    }, null, 8, ["value", "invalid", "invalid-message", "onInput", "onEnter"])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _createVNode(_component_MTextField, {
                      label: "間隔の上限(分)",
                      name: "max",
                      type: "number",
                      placeholder: "間隔の上限を入力してください",
                      value: String(_ctx.max),
                      invalid: !_ctx.isMaxValid,
                      "invalid-message": _ctx.maxInvalidMessage,
                      entered: "",
                      onInput: _ctx.onMaxInput,
                      onEnter: _ctx.onMaxBlur
                    }, null, 8, ["value", "invalid", "invalid-message", "onInput", "onEnter"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_18, [
        _createVNode(_component_m_button, {
          color: "primary-500",
          "hover-color": "primary-600",
          disabled: !_ctx.isValidData,
          onClick: _ctx.updateSetting
        }, {
          default: _withId(() => [
            _hoisted_19
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
})